import * as React from 'react';

import { useLocation, useHistory } from 'react-router-dom';

import UnsavedChangesContext from 'common/components/withUnsavedChanges/context';

/**
 * The UnsavedChangesListener component.
 *
 * The component that just renders a Prompt that should be shown when the user navigates with some
 * unsaved changes.
 * The actual dialog is not rendered here - it's handled by the Router's getUserConfirmation prop.
 */
export default function UnsavedChangesListener() {
  const context = React.useContext(UnsavedChangesContext);
  const location = useLocation();
  const history = useHistory();
  const { setUnsavedChanges } = context;

  React.useEffect(
    () => history.block((_, action) => (action === 'PUSH' && context.hasUnsavedChanges ? '' : undefined)),
    [context.hasUnsavedChanges, history]
  );

  React.useEffect(() => {
    setUnsavedChanges(false);
  }, [location, setUnsavedChanges]);

  return null;
}
